export function formatIsoToDateString(iso: string | Date): string {
	const d = new Date(iso);
	return d.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatIsoToTimeString(iso: string | Date): string {
	const d = new Date(iso);
	return d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: undefined });
}

export function getStartOfMonthAsDateString(date = new Date()): string {
	return new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString();
}

export function getEndOfMonthAsDateString(date = new Date()): string {
	return new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString();
}

export function formatMonthString(date = new Date(), separator = ', '): string {
	const month = date.toLocaleString('default', { month: 'long' });
	const year = date.toLocaleString('default', { year: 'numeric' });
	return `${month}${separator}${year}`;
}

export function getStartOfMonth(date = new Date()): Date {
	return new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
}

export function getEndOfMonth(date = new Date()): Date {
	const d = new Date(date);
	d.setMonth(d.getMonth() + 1);
	d.setDate(0);
	d.setHours(23, 59, 59, 999);
	return d;
}
